<template>
  <section>
    <div class="container" data-aos="fade-up">
      <div class="section-title">
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
    }
  },
  created() {
    this.validatePayment();
  },
  methods: {
    validatePayment() {
      let data = this.$route.query;
      let instance = this;
      axios.get(`${this.apiPath}single-topup-client?uniqueId=${data.txID}&mobile=${localStorage.getItem('mobile')}&type=${localStorage.getItem('type')}&operator=${localStorage.getItem('operator')}&amount=${data.txnAmount}&email=${localStorage.getItem('email')}&payment_method=${localStorage.getItem('payment_method')}`)
          .then(function (response) {
            console.log(response)
            setTimeout(function (){
              instance.$router.push('/topup-success');
            },1000);
          }).catch(function (error) {
            console.log(error);
      });
    }
  }
}
</script>

<style scoped>

</style>